import axios from "axios";
import { IOTPRequest } from "../models/request/IOTPRequest";
import { IPhoneVerifyRequest } from "../models/request/IPhoneVerifyRequest";

export const sendOTPApi = async (queryParams: IOTPRequest) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/phoneAuth.php`,
    {
      ...queryParams,
      action: "sendOTP",
    }
  );
  return response.data;
};

export const verifyOTPApi = async (queryParams: IPhoneVerifyRequest) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/phoneAuth.php`,
    {
      ...queryParams,
      action: "verifyOTP",
    }
  );
  return response.data;
};
